import { useMutation } from '@tanstack/react-query'

import { usersLoginAdminCreateMutation } from 'src/api/main'
import { useSessionContext } from 'src/hooks'
import { useShowApiErrors } from 'src/utils'

export const useUpdateUserContext = () => {
  const { updateUserData } = useSessionContext()
  const showApiErrors = useShowApiErrors()

  const { mutateAsync: updateUser, isPending: isPendingUser } = useMutation({
    ...usersLoginAdminCreateMutation(),
    onSuccess: (userData) => updateUserData(userData),
    onError: (e) => showApiErrors(e)
  })

  return { updateUser, isPendingUser }
}
